module.exports = {"371402001":"新湖街道","371402002":"新华街道","371402003":"天衢街道","371402006":"广川街道","371402009":"运河街道","371402100":"二屯镇","371402101":"黄河涯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371402.json
// module id = 1590
// module chunks = 0